import { HttpClient } from '@angular/common/http';
import { Component, Inject, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { Utils } from '../../../../../utils/utils';

@Component({
    selector: "userlicense",
    templateUrl: './userlicense.component.html',
    styleUrls: ['./userlicense.component.less', '../../../../../style/new-generic-styles.component.less'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})

export class UserLicenseComponent {

    filteredLicenseItems: any[] = [];
    userLicenses: any[] = [];
    licenseSearchValue: string = '';

    userId = ''

    Response_State: number = -2; //0 -> empty , 1 -> correct and not empty ,-1 -> error, -2 -> Calling API
    showData: boolean = false;

    constructor(
        private readonly route: ActivatedRoute,
        private readonly http: HttpClient,
        @Inject('BASE_URL') private readonly baseUrl: string
    ) {
        this.route.params.subscribe(
            (params: Params) => {
                this.hideData();
            });
    }

    resetAll() {
        this.userId = ''
        this.showData = true;
        this.Response_State = -2; //0 -> empty , 1 -> correct and not empty ,-1 -> error, -2 -> Calling API
        this.userId = this.route.snapshot.paramMap.get('userId') || '';
        this.funcGetUserLicenses();
    }

    funcGetUserLicenses() {
        this.Response_State = -2;
        Utils.httpGetUserLicenses(
            this.http
            , this.baseUrl
            , this.userId
            , this
            , function (tthis: UserLicenseComponent, data: any) {
                tthis.userLicenses = data.userLicenses
                tthis.filteredLicenseItems = tthis.userLicenses
                tthis.Response_State = 1;
            }
        )
    }

    async updateLicenseResults() {
        this.filteredLicenseItems = this.searchByValue(this.userLicenses, "skuName", this.licenseSearchValue);
    }

    searchByValue(items: any, filterProperty: string, query: string): any {

        return items.filter(item => {
            if (query.trim() === '') {
                return true;
            } else {
                return item[filterProperty].toLowerCase().includes(query.trim().toLocaleLowerCase())
            }
        })
    }

    hideData() {
        this.showData = false;
        this.userLicenses = [];
        this.filteredLicenseItems = [];
    }
}